import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./style.css";

import Container from "components/Container";
import React from "react";
import { faGithub } from "@fortawesome/free-brands-svg-icons";
import { faExternalLink } from "@fortawesome/free-solid-svg-icons";

export default function ProjectLink({ gitLink, webLink }) {
	return (
		<Container containerClass="project-link-container">
			{gitLink && (
				<a
					href={gitLink}
					target="_blank"
                    rel="noreferrer"
					className="project-link-git expand-sm"
					title="Visa projekt i GitHub"
				>
					<FontAwesomeIcon
						icon={faGithub}
						className="project-link-git-icon "
					/>
				</a>
			)}
			{webLink && (
				<a
					href={webLink}
					target="_blank"
                    rel="noreferrer"
					className="project-link-web expand-sm"
					title="Gå till projektets webbplats"
				>
					<FontAwesomeIcon
						icon={faExternalLink}
						className="project-link-web-icon"
					/>
				</a>
			)}
		</Container>
	);
}
